import { useCallback } from "react";
import { apiNiches } from "@/common/services";
import { usePaginatedFeed } from "@/common/hooks/usePaginatedFeed";
import { useGifPreviewNicheStore } from "@/common/store/gifPreviewNicheStore";

interface IProps {
  order: string;
  query?: string;
  verified?: boolean;
  tags?: string;
  category?: string;
}

export const useSearchNichesPreviews = ({ order, query, tags, category }: IProps) => {
  const setGifPreviewNiches = useGifPreviewNicheStore(state => state.setGifPreviewNiches);

  const request = useCallback((page?: number) => {
    return apiNiches.searchNichesPreviews({
      order,
      count: 30,
      query,
      tags,
      category: category === "All" ? undefined : category,
      page: page || 1,
    }).then((res) => {
      setGifPreviewNiches(
        res.gifs
          .map(gif => ({ gifId: gif.id, nicheId: gif.niches[0] })),
      );

      return res;
    });
  }, [order, query, tags, category, setGifPreviewNiches]);

  const feed = usePaginatedFeed(["nichesPreviewsGifs", order, query, tags, category], request);

  return { feed };
};
